import React from 'react';

export const PainelAdminVendedoresTab = ({
  vendedores,
  setShowAddVendedor,
  copyLink,
  handleToggleAtivo,
  openEdit,
  handleDeleteVendedor,
}) => {
  return (
    <>
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-3">
          <span className="text-4xl">👥</span>
          <div>
            <h2 className="text-2xl font-bold text-gray-900" data-testid="painel-admin-vendedores-title">Gestão de Vendedores</h2>
            <p className="text-gray-600" data-testid="painel-admin-vendedores-count">{vendedores.length} vendedores cadastrados</p>
          </div>
        </div>
        <button onClick={() => setShowAddVendedor(true)} className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700" data-testid="painel-admin-add-vendedor-button">
          + Novo
        </button>
      </div>

      <div className="space-y-3" data-testid="painel-admin-vendedores-list">
        {vendedores.map((v) => (
          <div key={v.id} className={`border rounded-xl p-4 ${v.ativo ? 'border-gray-200' : 'border-red-200 bg-red-50 opacity-60'}`} data-testid={`painel-admin-vendedor-card-${v.id}`}>
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center text-xl">👤</div>
                <div>
                  <div className="font-semibold text-gray-900" data-testid={`painel-admin-vendedor-name-${v.id}`}>{v.nome}</div>
                  <div className="text-sm text-gray-500">{v.especialidade} • {v.leads_count || 0} leads</div>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <button onClick={() => copyLink(v.codigo)} className="px-3 py-1 bg-green-100 text-green-700 rounded text-sm hover:bg-green-200" data-testid={`painel-admin-copy-link-button-${v.id}`}>
                  📋 Link
                </button>
                <button onClick={() => handleToggleAtivo(v)} className={`px-3 py-1 rounded text-sm ${v.ativo ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'}`} data-testid={`painel-admin-toggle-ativo-button-${v.id}`}>
                  {v.ativo ? '✓ Ativo' : '✗ Inativo'}
                </button>
                <button onClick={() => openEdit(v)} className="px-3 py-1 bg-blue-100 text-blue-700 rounded text-sm hover:bg-blue-200" data-testid={`painel-admin-edit-vendedor-button-${v.id}`}>
                  ✏️
                </button>
                <button onClick={() => handleDeleteVendedor(v)} className="px-3 py-1 bg-red-100 text-red-700 rounded text-sm hover:bg-red-200" data-testid={`painel-admin-delete-vendedor-button-${v.id}`}>
                  🗑️
                </button>
              </div>
            </div>
            <div className="mt-2 text-xs text-gray-400" data-testid={`painel-admin-vendedor-link-preview-${v.id}`}>Link: /v/{v.codigo}</div>
          </div>
        ))}
      </div>
    </>
  );
};
